import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import Image from "src/components/Image";
import { Box, Stack, Typography } from "@mui/material";

const EXHIBITIONS = [
  { name: "afri-stay", icon: "bed-time_16272938.gif" },
  { name: "afri-pay", icon: "pattern_19003120.gif" },
  { name: "afri-boat", icon: "tv-show_13890956.gif" },
  { name: "afri-home", icon: "computer_18116850.gif" },
  { name: "afri-car", icon: "app_18946100.gif" },
  { name: "afri-ticket", icon: "tickets_8701351.gif" },
];
export const DivLoop = () => {
  const [index, setIndex] = useState(0);
  useEffect(() => {
    setTimeout(() => {
      let next = index + 1;
      setIndex(next % EXHIBITIONS.length);
    }, 3 * 1000);
  }, [index, setIndex]);

  return (
    <Box
      display="inline"
      position="relative"
      w="100%"
      sx={{ flexGrow: 1, flexShrink: 0 }}
    >
      <AnimatePresence initial={false}>
        <motion.div
          position="absolute"
          key={index}
          layout
          variants={{
            enter: {
              translateY: 20,
              opacity: 0,
              height: 0,
            },
            center: {
              zIndex: 1,
              translateY: 0,
              opacity: 1,
              height: 50,
              width: "auto",
            },
            exit: {
              zIndex: 0,
              translateY: -20,
              opacity: 0,
              height: 0,
              width: "auto",
            },
          }}
          initial="enter"
          animate="center"
          exit="exit"
          transition={{
            translateY: {
              type: "spring",
              duration: 0.2,
              bounce: 0.4,
            },
            opacity: { duration: 0.5 },
          }}
        >
          <Stack direction="row" alignItems="center" spacing={2}>
            <Typography
              variant="body2"
              sx={{
                color: "#000",
                fontSize: 20,
                fontFamily: '"Protest Riot", sans-serif',
              }}
            >
              {EXHIBITIONS[index].name}
            </Typography>
            <Image
              src={`/static/${EXHIBITIONS[index].icon}`}
              alt={EXHIBITIONS[index].name}
              width={50}
              height={50}
            />
          </Stack>
        </motion.div>
      </AnimatePresence>
    </Box>
  );
};
